import { useState, useEffect } from 'react';
import firebase from 'firebase/app';

/**
 * Subscribes to clients/{clientId}/changehistory subcollection.
 * Only runs when clientId is provided. Unsubscribes on unmount.
 * @param {string|null} clientId
 * @returns {Array} change history entries (or empty array)
 */
export function useClientChangeHistory(clientId) {
  const [changeHistory, setChangeHistory] = useState([]);

  useEffect(() => {
    if (!clientId) {
      setChangeHistory([]);
      return;
    }

    const db = firebase.firestore();
    const unsubscribe = db
      .collection('clients')
      .doc(clientId)
      .collection('changehistory')
      .orderBy('createdAt', 'desc')
      .limit(50)
      .onSnapshot(
        (snap) => {
          const data = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
          setChangeHistory(data);
        },
        (e) => {
          console.warn('Change history subscription error:', e);
          setChangeHistory([]);
        }
      );

    return () => {
      unsubscribe();
      setChangeHistory([]);
    };
  }, [clientId]);

  return changeHistory;
}
